export const FONTSIZE = {
  LARGE: 'LARGE',
  SMALL: 'SMALL',
}
